import { Input } from "@/components/ui/input";
import DependentQuestions from "@/containers/survey/components/DependentQuestions";
import { useTranslation } from "react-i18next";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import { isRequired } from "@/lib/form";
import { cfg } from "@/schemas/question/cfg";

interface QuestionTextareaProps {
  index: number;
}

const QuestionTextarea = ({ index }: QuestionTextareaProps) => {
  const { t } = useTranslation();

  return (
    <Fieldset>
      <Field
        name={`questions.${index}.cfg.minLength`}
        label={t("surveyEditor.common.minLength")}
        required={isRequired(cfg.shape.minLength)}
        render={({ field }) => (
          <Input type="number" className="w-24" {...field} />
        )}
      />
      <Field
        name={`questions.${index}.cfg.maxLength`}
        label={t("surveyEditor.common.maxLength")}
        required={isRequired(cfg.shape.maxLength)}
        render={({ field }) => (
          <Input type="number" className="w-24" {...field} />
        )}
      />
      <DependentQuestions index={index} />
    </Fieldset>
  );
};

export default QuestionTextarea;
